import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useVideoTime } from "../../../VideoContextProvider/context/state/time.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { useIsVideoPaused } from "../../../VideoContextProvider/context/state/isPaused.js";
/* empty css           */
const LiveButton = () => {
  const { t } = useTranslation();
  const { play } = useVideoController();
  const { isAtLiveEdge, seekToLiveEdge } = useVideoTime();
  const isPaused = useIsVideoPaused();
  const seekToLive = () => {
    !isAtLiveEdge && seekToLiveEdge();
    isPaused && play();
  };
  const buttonText = isAtLiveEdge ? t("Live") : t("Not Live");
  return /* @__PURE__ */ jsxs(
    "button",
    {
      onClick: () => seekToLive(),
      className: "omega_liveBtn",
      "aria-label": buttonText,
      "data-testid": "live-button",
      children: [
        !!isAtLiveEdge && /* @__PURE__ */ jsx("span", { className: "omega_liveBtn-dot" }),
        /* @__PURE__ */ jsx("span", { className: "omega_liveBtn-label", children: buttonText })
      ]
    }
  );
};
export {
  LiveButton
};
//# sourceMappingURL=index.js.map
